export default __webpack_public_path__ + "static/media/table-filter.67c2c1c2.svg";